import { updateReimbursementAll } from '../../../../services/ReimbursementService';
import { baseUrl_SPB } from '../../../../BaseUrl';

export async function reconcileExpenseWithPaidY(reimbursement, token) {
  const payload = { ...reimbursement, paid: 'Y' };
  return updateReimbursementAll(payload, token);
}

export async function reconcileInvoiceWithPaidY(invoice, token) {
  const response = await fetch(`${baseUrl_SPB}/api/v1/invorquote/save`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    },
    body: JSON.stringify(invoice),
  });
  return response.json();
}
